module.exports = __webpack_public_path__ + "img/red_pin.png";